import { useEffect } from 'react';

const DEFAULT_FAVICON = '/favicon.svg';

/**
 * Dynamically update the page favicon.
 * Falls back to the static /favicon.svg when no custom URL is provided.
 *
 * @param faviconUrl - Absolute or relative URL to a favicon image, or null/undefined for default
 */
export function useDynamicFavicon(faviconUrl: string | null | undefined): void {
  useEffect(() => {
    const href = faviconUrl || DEFAULT_FAVICON;
    const link: HTMLLinkElement =
      document.querySelector("link[rel='icon']") ??
      (() => {
        const el = document.createElement('link');
        el.rel = 'icon';
        document.head.appendChild(el);
        return el;
      })();

    // Determine type from URL extension
    if (href.endsWith('.svg')) {
      link.type = 'image/svg+xml';
    } else if (href.endsWith('.webp')) {
      link.type = 'image/webp';
    } else if (href.endsWith('.png')) {
      link.type = 'image/png';
    } else if (href.endsWith('.ico')) {
      link.type = 'image/x-icon';
    } else {
      link.removeAttribute('type');
    }

    link.href = href;
  }, [faviconUrl]);
}
